import { ErrorReporter } from '@wix/editor-error-reporter';
import { arrayUtils } from '#packages/util';

import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef, Docking } from 'types/documentServices';
/**
 * @deprecated use fullWidth and pin API instead
 */
export function createLayoutDockApi({ editorAPI }: { editorAPI: EditorAPI }) {
  /**
   * @deprecated
   */
  function isDocked(compRefOrRefs: CompRef | CompRef[]) {
    const compRefs = arrayUtils.asArray(compRefOrRefs);

    return compRefs.every((compRef) => {
      // source https://github.com/wix-private/document-management/blob/b30cc2ea84908fdde8bbb2ceecbafc08992c9dfb/document-services-implementation/src/structure/structure.ts#L825
      return editorAPI.dsRead.components.layout.isDocked(compRef);
    });
  }

  /**
   * @deprecated
   */
  function isDockedToScreen(compRefOrRefs: CompRef | CompRef[]) {
    const compRefs = arrayUtils.asArray(compRefOrRefs);

    return compRefs.every((compRef) => {
      return editorAPI.dsRead.components.layout.isDockedToScreen(compRef);
    });
  }

  interface DockingUpdateDepticationOptions {
    allowOneDocAdapter_DONT_USE?: boolean;
  }

  /**
   * @deprecated use steatch/unstreach and pin/unpin instead
   */
  function unDock(compRefOrRefs: CompRef | CompRef[]) {
    const compRef = arrayUtils.asSingleThrowIfMultiple(compRefOrRefs);

    // eslint-disable-next-line @wix/santa-editor/deprecatedDSApi
    editorAPI.dsActions.components.layout.unDock(compRef);
  }

  /**
   * @deprecated use steatch/unstreach and pin/unpin instead
   */
  function setDock(
    compRefOrRefs: CompRef | CompRef[],
    newValue: Docking,
    options: DockingUpdateDepticationOptions = {},
  ): void {
    const compRef = arrayUtils.asSingleThrowIfMultiple(compRefOrRefs);

    if (editorAPI.sections.isHeaderOrFooter(compRef)) {
      ErrorReporter.captureException(
        new Error('Setting dock for header or footer'),
        {
          extra: {
            newValue,
            options,
          },
        },
      );
    }

    // eslint-disable-next-line @wix/santa-editor/deprecatedDSApi
    editorAPI.dsActions.components.layout.setDock(compRef, newValue);
  }

  /**
   * @deprecated
   */
  function getDock(compRefOrRefs: CompRef | CompRef[]): Docking {
    const compRef = arrayUtils.asSingleThrowIfMultiple(compRefOrRefs);

    // eslint-disable-next-line @wix/santa-editor/deprecatedDSApi
    return editorAPI.dsRead.components.layout.getDock(compRef);
  }

  /**
   * @deprecated use steatch/unstreach and pin/unpin instead
   */
  function updateDock(
    compRefOrRefs: CompRef | CompRef[],
    newValue: Docking,
  ): void {
    const compRef = arrayUtils.asSingleThrowIfMultiple(compRefOrRefs);

    // eslint-disable-next-line @wix/santa-editor/deprecatedDSApi
    editorAPI.dsActions.components.layout.updateDock(compRef, newValue);
  }

  return {
    isDocked,
    isDockedToScreen,
    setDock,
    updateDock,
    unDock,
    getDock,
  };
}

export type LayoutDockApi = ReturnType<typeof createLayoutDockApi>;
